import { Sol } from '@seek/candidate-sol-js/dist/commonjs/sol.js';
import getJobSeekerId from './utils/getJobSeekerId';
import { solConfig } from 'src/config';
import { get } from 'lodash';

const getPartnerId = origin => (/.co.nz$/.test(origin) ? 'SEEK_NZ' : 'SEEK_AU');

const initSol = () => {
  try {
    if (!get(window, 'sol.loaded')) {
      // This must happen before sol = window.sol
      new Sol(); // eslint-disable-line no-new
    }
  } catch (e) {
    console.error('SOL', e); // eslint-disable-line no-console
  }

  window.sol('INIT', getPartnerId(window.location.origin), {
    loginId: getJobSeekerId(window.localStorage),
    ...solConfig
  });
};

initSol();
